import { useEffect, useState, useMemo } from 'react';
import {
  fetchSearchTrendingConfig,
  fetchUserSearchTrendingStatus,
} from '@/pages/home/services/search';
import { TRENDING_KEY } from '@/pages/home/components/NavHeader/_config';
import useDebounce from '@intelligence/components/GenreSelectMiddleware/Supports/_hooks/useDebounce';

// useSearchModel-首页搜索通用数据处理hooks
const useSearchModel = (props: any) => {
  const { completeOptions, inputValue } = props;
  const [searchTrendingList, setSearchTrendingList] = useState<any[]>([]);
  // 搜索下拉Trending是否展开
  const [openTrending, setOpenTrending] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchSearchTrendingConfig()
      .then(list => {
        if (!cancelled) {
          setSearchTrendingList(list);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setSearchTrendingList([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // 获取用户上一次搜索下拉Trending状态
  const getOpenTrendingStatus = async () => {
    const params = {
      action: 'get',
      keys: [TRENDING_KEY],
    };
    try {
      const result: any = await fetchUserSearchTrendingStatus(params);
      // console.log('result', result);
      const openValue = result?.[TRENDING_KEY] !== 'close';
      setOpenTrending(openValue);
    } catch (err) {
    } finally {
    }
  };

  const setOpenTrendingStatus = useDebounce(async (openTrending: boolean) => {
    const params = {
      action: 'set',
      key: TRENDING_KEY,
      value: openTrending ? 'open' : 'close',
    };
    try {
      // 当前请求发起时将之前请求取消
      await fetchUserSearchTrendingStatus(params);
    } catch (err) {
    } finally {
    }
  }, 300);

  const trendingList = useMemo(() => {
    return completeOptions?.filter((item: any) => item.groupKey === 'Trending') || [];
  }, [completeOptions]);
  const recentList = useMemo(() => {
    return completeOptions?.filter((item: any) => item.groupKey === 'Recent') || [];
  }, [completeOptions]);
  const searchList = useMemo(() => {
    return completeOptions?.filter((item: any) => item.groupKey === 'Search') || [];
  }, [completeOptions]);

  // 是否展示下拉Trending
  const isShowTrending = useMemo(() => {
    return inputValue === '';
  }, [inputValue]);

  // 是否展示下拉Trending
  const isSearchPullNoData = useMemo(() => {
    return !isShowTrending && !recentList?.length && !searchList?.length;
  }, [recentList, isShowTrending, searchList]);

  return {
    openTrending,
    setOpenTrending,
    getOpenTrendingStatus,
    setOpenTrendingStatus,
    searchTrendingList,
    trendingList,
    recentList,
    searchList,
    isShowTrending,
    isSearchPullNoData,
  };
};

export default useSearchModel;
